import { useScreenWidth } from 'data/hooks/useScreenWidth'
import { unescapeHtml } from 'data/helpers/html'
import classNames from 'classnames'
import Searchbar from './Searchbar'

type MenuOption = {
  id: string
  name: string
}

type MenuListPropTypes = {
  options: MenuOption[]
  currentOption: MenuOption['id']
}

const MenuList = ({ options, currentOption }: MenuListPropTypes) => {
  const { isMobile } = useScreenWidth(1024)

  return (
    <>
      {
        options && options.map((option, key) => (
          <a
            key={key}
            href={`/${option.id}`}
            className={classNames(
              'uppercase text-14 text-grey-800 tracking-[1.5px] leading-title font-bold',
              {
                'py-5': isMobile,
                'py-10': !isMobile,
                'border-b-2 border-primary': currentOption === (option?.id),
                'border-transparent': currentOption !== (option?.id),
              },
            )}
          >
            {unescapeHtml(option.name)}
          </a>
        ))
      }
    </>
  )
}

type PropTypes = {
  currentPage: MenuOption['id']
}

const PartnerSearchbar = ({ currentPage }: PropTypes) => {
  const options = [
    {
      id: 'owners',
      name: 'Owners',
    },
    {
      id: 'travel-partners',
      name: 'Travel Partners',
    },
  ]

  return (
    <>
      <Searchbar
        showBookButton={false}
        OptionComponent={() => <MenuList options={options} currentOption={currentPage}/>}
      />

    </>
  )
}

export default PartnerSearchbar
